export default [
    {
        path: "/admin/sangkat-communes",
        name: "sangkat-commune",
        meta: true,
        component: () => import("@/pages/corporate/sangkat-commune/index.vue")
    },
];
